import { render, staticRenderFns } from "./NewMessageForm.vue?vue&type=template&id=4634399a"
import script from "./NewMessageForm.vue?vue&type=script&lang=js"
export * from "./NewMessageForm.vue?vue&type=script&lang=js"
import style0 from "./NewMessageForm.vue?vue&type=style&index=0&id=4634399a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports